import { authApi } from './authApi'
import { jobApi } from './jobApi'
import { workflowApi } from './workflowApi'
import { assetApi } from './assetApi'

export { nordyAxios } from './client'
export { authApi } from './authApi'
export { jobApi } from './jobApi'
export { workflowApi } from './workflowApi'
export { assetApi } from './assetApi'

/**
 * 기존 nordyApi.xxx() 호출과 호환되는 통합 객체
 */
export const nordyApi = {
  ...authApi,
  ...jobApi,
  ...workflowApi,
  ...assetApi
}
